import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import TableLayout from "../../../../components/TableLayout";
import { CstmPagination } from "../../../../components/Common/Common";
import ConfirmationPop from "../../../../components/Modals/ConfirmationPop";
import dataHandler from "../../../../hooks/dataHandler";
import {
  DELETE_PROVIDER,
  SERVICE_PROVIDERS_LIST,
  STATUS_CHANGE_SERVICE_PROVIDER,
  USER_LIST,
} from "../../../../services/ApiCalls";
import CustomPagination from "../../../../components/Common/CustomPagination";
import TableActions from "../../../../components/Common/TableActions";
import Toggle from "../../../../components/Common/Toggle";
import Filter from "../../../../components/Common/Filter";
import {
  activeInActiveArr,
  activeInactiveOptions,
  csvImportEnum,
} from "../../../../utilities/const";
import moment from "moment";
import {
  capitalizedFirstAlphaBet,
  exportCsvHandler,
  findLabelOfAccountType,
  removeUnderScoreAndCapitalizeFirstLetter,
} from "../../../../utilities/utilities";
import ButtonLoader from "../../../../components/Common/ButtonLoader";
import ImportCsv from "../../../../components/Common/ImportCsv";

const RegisterServiceProvider = () => {
  const [exportCsvLoader, setExportCsvLoader] = useState(false);
  const {
    setBody,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    refetch,
    total,
    deleteHandler,
    statusChangeHandler,
  } = dataHandler({
    api: USER_LIST,
    extraBody: {
      type: "registered",
      role: "EXPERT",
    },
  });

  const column = [
    {
      head: "#",
      accessor: "#",
      component: (item, key) => {
        return <>{body.limit * (body.page - 1) + key + 1}</>;
      },
    },
    {
      head: "Name",
      accessor: "name",
      component: (item, key, arr) => (
        <p className="m-0 themeBlue fw-sbold">
          {capitalizedFirstAlphaBet(item.fname + item.lname)}
        </p>
      ),
    },
    // {
    //   head: "Speciality",
    //   accessor: "speciality",
    //   component: (item, key, arr) => (
    //     <p className="m-0 themeBlue fw-sbold">
    //       {capitalizedFirstAlphaBet(item?.serviceTypeDetails?.catName) || ""}
    //     </p>
    //   ),
    // },
    { head: "Email", accessor: "email" },
    {
      head: "Created At",
      accessor: "createdAt",
      component: (item, key, arr) => (
        <>{moment(item.date_created_utc).format("DD-MM-YYYY , HH:MM")}</>
      ),
    },
    // {
    //   head: "Account Type",
    //   accessor: "accountType",
    //   component: (item) => <>{findLabelOfAccountType(item.accountType)}</>,
    // },
    {
      head: "Price Per Hour",
      accessor: "pricePerHour",
      component: (item) => <>{item.pricePerHour || 0.0}</>,
    },
    {
      head: "Average User Ratings",
      accessor: "avgRating",
      component: (item) => <>{item.avgRating || 0}</>,
    },

    {
      head: "Total Earning",
      accessor: "totalearning",
      component: (item) => <>{item?.totalearning || 0.0}</>,
    },
    {
      head: "Total Withdrawal",
      accessor: "totalwithdrawal",
      component: (item) => <>{item?.totalwithdrawal || 0.0}</>,
    },
    {
      head: "Total Revenue",
      accessor: "totalRevenue",
      component: (item) => <>{item.totalRevenue || 0.0}</>,
    },
    {
      head: "Appointment Volume",
      accessor: "orderTotalCount",
      component: (item) => <>{item.orderTotalCount || 0}</>,
    },
    {
      head: "Status",
      accessor: "status",
      component: (item, key) => (
        <Toggle
          isChecked={item?.status === "active" || item?.status === "approved"}
          onChange={(e) =>
            statusChangeHandler(
              () =>
                STATUS_CHANGE_SERVICE_PROVIDER({
                  _id: item._id,
                  status: item?.status === "active" ? "inactive" : "active",
                }),
              key
            )
          }
        />
      ),
    },
    {
      head: "Action",
      accessor: "Action",
      component: (item) => (
        <TableActions
          editUrl={`/service-provider/register/edit/${item._id}`}
          viewLink={`/service-provider/register/detail/${item._id}`}
          setDeleteModel={() =>
            setDeleteModel({ dumpId: item._id, show: true })
          }
        />
      ),
    },
  ];

  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel({ show: false, dumpId: "" })}
        confirmHandler={() =>
          deleteHandler(() => DELETE_PROVIDER({ _id: deleteModel.dumpId }))
        }
      />
      <section className="serviceProvider py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                Registered Therapist
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    searchHandler={searchHandler}
                    setBody={setBody}
                    statusFilterOptionArr={activeInactiveOptions}
                  />
                </div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    <li className="">
                      <ImportCsv
                        callBack={() => refetch()}
                        item={csvImportEnum.serviceProvider}
                      />
                    </li>
                    <li className="">
                      <Button
                        className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                        onClick={() =>
                          exportCsvHandler(
                            "service-providers",
                            setExportCsvLoader
                          )
                        }
                      >
                        {exportCsvLoader ? <ButtonLoader /> : "Export CSV"}
                      </Button>
                    </li>
                    {/* <li className="">
                      <Link
                        to="/service-provider/register/add"
                        className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                      >
                        Add New
                      </Link>
                    </li> */}
                  </ul>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default RegisterServiceProvider;
